class Header extends DrupalBehavior {
  onContent(context) {
    const header = context.querySelector('header');
    if (header) {
      once('header-initialization', header, context).forEach(() => {
        this.mobileMenuToggle = document.querySelector('.header--mobile-toggle');
        this.searchToggle = document.querySelector('.header--search-toggle');
        this.menu = document.querySelector('.header--navigation');
        this.lastMenuItem = document.querySelector('.main-menu .level-1:last-of-type a');
        if (!this.mobileMenuToggle || !this.searchToggle || !this.menu || !this.lastMenuItem) {
          header.classList.add('processed');
          return;
        }
        this.mql = window.matchMedia('(max-width: 991px)');
        this.bindEvents();
        this.mql.addListener(this.init);
        this.init(this.mql);
        header.classList.add('processed');
      });
    } else {
      return;
    }
  }

  bindEvents() {
    this.init = this.init.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.triggerClose = this.triggerClose.bind(this);
    this.mobileTabOrder = this.mobileTabOrder.bind(this);
  }

  mobileTabOrder(e) {
    e.preventDefault();
    if (Number(e.keyCode) === 9) {
      if (e.shiftKey) {
        this.lastMenuItem.parentNode.previousElementSibling.querySelector('a').focus();
      } else {
        this.mobileMenuToggle.focus();
      }
    }
  }

  openMenu() {
    this.menu.classList.remove('hidden');
    gsap.to(this.menu, { duration: 0.4, ease: 'power4.out', height: 'auto' });
    this.menu.querySelector('.utility-menu .level-1 a').focus();
  }

  closeMenu() {
    gsap.to(this.menu, { duration: 0.4, ease: 'power4.out', height: 0, onComplete: function() {
      this.menu.classList.add('hidden');
    }.bind(this) });
  }

  triggerClose() {
    this.mobileMenuToggle.classList.remove('open');
    this.mobileMenuToggle.setAttribute('aria-expanded', false);
    this.closeMenu();
  }

  toggleMenu() {
    this.mobileMenuToggle.classList.toggle('open');
    if (this.mobileMenuToggle.classList.contains('open')) {
      this.mobileMenuToggle.setAttribute('aria-expanded', true);
      this.openMenu();
    } else {
      this.mobileMenuToggle.setAttribute('aria-expanded', false);
      this.closeMenu();
    }
  }

  init(media) {
    this.mobileMenuToggle.setAttribute('aria-haspopup', true);

    if (media.matches) {
      this.mobileMenuToggle.classList.remove('open');
      this.mobileMenuToggle.setAttribute('aria-expanded', false);
      this.menu.classList.add('hidden');
      this.menu.style.height = 0;

      this.mobileMenuToggle.addEventListener('click', this.toggleMenu, true);
      this.searchToggle.addEventListener('click', this.triggerClose, true);
      this.lastMenuItem.addEventListener('keydown', this.mobileTabOrder, true);
    } else {
      this.mobileMenuToggle.classList.add('open');
      this.mobileMenuToggle.setAttribute('aria-expanded', true);
      this.menu.classList.remove('hidden');
      this.menu.style.height = 'auto';

      this.mobileMenuToggle.removeEventListener('click', this.toggleMenu, true);
      this.searchToggle.removeEventListener('click', this.triggerClose, true);
      this.lastMenuItem.removeEventListener('keydown', this.mobileTabOrder, true);
    }
  }


}

DrupalBehavior.register('summit_theme', 'Header', Header);